export default __webpack_public_path__ + "static/markedwaxwithdust-6d21c3b3c7a40c1239b86b326b589db1.png";